import * as React from "react";
import { inject, observer } from "mobx-react";

import { getComponentFromView } from "./utils/WizardHotelPWAv2Utils";
import { WizardHotelPWAv2Props, WizardHotelPWAv2FTNodeOptions } from "./typings";
import { normalizeOptionsData } from "src/components/flexFramework/FlexTemplateNode";
import { TravelAgentSearchWizardConfigStore } from "stores/TravelAgentSearchWizardConfigStore";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { TravelAgentSearchWizardConfigQuery } from "../../../../__generated__/api";
import { Experiment, isVariantEnabled } from "components/utility/experiment";
import TravelAgentSearchWizardConfig = TravelAgentSearchWizardConfigQuery.TravelAgentSearchWizardConfig;

@inject(
  "analytics",
  "experiment",
  "page",
  "wizardState",
  "compositionStore",
  "flexModuleModelStore",
  "flexViewModel",
  "travelAgentSearchWizardConfigStore"
)
@observer
export class WizardHotelPWAv2 extends React.Component<WizardHotelPWAv2Props> {
  private options: WizardHotelPWAv2FTNodeOptions;

  constructor(props: WizardHotelPWAv2Props) {
    super(props);

    const hotelWizardState = this.props.wizardState.hotelWizardState;
    const hotelWizardConfig = hotelWizardState.config;
    const isDesktop = Boolean(
      !this.props.context.deviceInformation?.mobile && !this.props.context.deviceInformation?.tablet
    );
    const { flexTemplateNode, flexModuleModelStore, flexViewModel } = this.props;
    const { id } = flexTemplateNode;

    const model = flexModuleModelStore.getModel(id);

    this.options = normalizeOptionsData(flexTemplateNode, model) as WizardHotelPWAv2FTNodeOptions;

    hotelWizardState.overrideConfig(() => {
      hotelWizardConfig.elementId = id;
      hotelWizardConfig.heading.fixedTitle = this.options.fixedLobTitle !== false;
      hotelWizardConfig.heading.title = this.options.lobTitle;
      hotelWizardConfig.lastSearch.useLastSearchForSingleLOB = this.options.useLastSearchForSingleLOB;
      hotelWizardConfig.includeFiltersHotelPWAWizard = this.options.includeFiltersHotelPWAWizard;
      hotelWizardConfig.analytics = this.props.analytics;
      hotelWizardConfig.enableMultiplePlaces = this.options.enableMultiplePlaces;
      if (!hotelWizardConfig.useTravelAgentSearchWizardConfig) {
        hotelWizardConfig.heading.hideLobTitle = this.options.hideLobTitle;
      }
      hotelWizardState.config.heading.lobSubtitleBreakPoint = this.options.lobSubtitleBreakPoint;
      hotelWizardConfig.siteIdsWithoutSoftPackages = this.options.siteIdsWithoutSoftPackages || [];
      hotelWizardConfig.desktopAutoOpenCalendar = Boolean(isDesktop && this.options.desktopAutoOpenCalendar);

      hotelWizardConfig.enablePackageRates = this.options.enablePackageRates ?? hotelWizardConfig.enablePackageRates;
      hotelWizardConfig.percentSave = this.options.percentSave ?? hotelWizardConfig.percentSave;
      hotelWizardConfig.packageRatesTermsUrl =
        this.options.packageRatesTermsUrl ?? hotelWizardConfig.packageRatesTermsUrl;
      hotelWizardConfig.showDestinationField =
        this.options.showDestinationField ?? hotelWizardConfig.showDestinationField;
      hotelWizardConfig.useTravelAgentSearchWizardConfig =
        this.options.useTravelAgentSearchWizardConfig ?? hotelWizardConfig.useTravelAgentSearchWizardConfig;

      const currentSiteId = props.context?.site?.id.toString();

      if (
        hotelWizardConfig.siteIdsWithoutSoftPackages.length !== 0 &&
        hotelWizardConfig.siteIdsWithoutSoftPackages.includes(currentSiteId)
      ) {
        hotelWizardConfig.enableAddFlight = false;
        hotelWizardConfig.enableAddCar = false;
      } else {
        hotelWizardConfig.enableAddFlight = this.options.enableAddFlight;
        hotelWizardConfig.enableAddCar = this.options.enableAddCar;
      }

      if (flexViewModel && flexViewModel.userLocation) {
        hotelWizardState.config.location.destination.essAdapterConfig.latLong =
          flexViewModel.userLocation.latitude + "," + flexViewModel.userLocation.longitude;
      }

      hotelWizardState.config.location.destination.essAdapterConfig.nearby = isVariantEnabled(
        this.props.context,
        Experiment.BEX_Driveable_destination_Web
      );
    });
    hotelWizardConfig.travelerType = this.options.defaultTravelerType;

    hotelWizardState.updateDateFromConfig();

    if (this.options.destinationFromContext) {
      hotelWizardState.updateDestinationFromContext(this.props.context);
    }
    if (this.options.titleFromPageHeader) {
      hotelWizardState.config.heading.differentiatedTitles = false;
    }
    if (this.options.subTitleFromPageSubHeader) {
      hotelWizardState.config.heading.lobSubtitleBreakPoint = "on";
    }
  }

  public componentDidMount() {
    const { hotelWizardState, globalWizardState } = this.props.wizardState;
    const hotelWizardConfig = hotelWizardState.config;

    if (globalWizardState.shouldUpdateCookie) {
      hotelWizardState.updateStateFromCookie();
    }
    if (hotelWizardConfig.useTravelAgentSearchWizardConfig) {
      const { travelAgentSearchWizardConfigStore, context } = this.props;
      this.fetchTravelAgentSearchWizardConfig(travelAgentSearchWizardConfigStore, context).then(
        (travelAgentConfig: TravelAgentSearchWizardConfig) => {
          hotelWizardState.updateFromTravelAgentConfig(travelAgentConfig);
        }
      );
    }
  }

  private fetchTravelAgentSearchWizardConfig(
    travelAgentSearchWizardConfigStore: TravelAgentSearchWizardConfigStore,
    context: ExtendedContextStore
  ) {
    return travelAgentSearchWizardConfigStore.fetchTravelAgentSearchWizardConfig(context);
  }

  public render() {
    const ViewComponent = getComponentFromView(this.options.flexComponentView);

    return <ViewComponent {...this.props} />;
  }
}

export default WizardHotelPWAv2;
